import React, { useState } from "react";
import Rating from "react-rating";

import styles from "./styles.module.scss";

// assets
import starFilled from "src/assets/images/details/star_filled.svg";
import star from "src/assets/images/details/star.svg";
import PlaceholderImg from "src/assets/images/details/person_placeholder.jpeg";

const Item = ({ data }) => {
  const [isError, setIsError] = useState(false);

  const getName = () => {
    return data.Name === "" ? "username" : data.Name;
  };

  return (
    <div className={styles.review}>
      <img
        src={!isError ? data.UserImagePath : PlaceholderImg}
        alt="review"
        onError={() => {
          setIsError(true);
        }}
      />
      <div>
        <h5>{getName()}</h5>
        <div className={styles.inner_stars}>
          <Rating
            initialRating={parseFloat(data.Ratings).toFixed(1)}
            emptySymbol={<img src={star} />}
            fullSymbol={<img src={starFilled} />}
            readonly
          />
        </div>
        <h6>{data.PostedDate}</h6>
        <p>{data.ReviewText}</p>
      </div>
    </div>
  );
};

export default Item;
